import * as React from 'react';
import { Image as WixImage, initCustomElement } from '@wix/image';
import { st, classes } from './Avatar.base.st.css';
import { nameToInitials } from './utils';
import { ImageLoadStates } from './types';
import { AVATAR_TEXT_TYPE } from './constants';
import { extractWixMediaId } from '../WowImage/utils';
export function AvatarBase({ name, src, onLoad, className, lettersLimit = 1, textType = AVATAR_TEXT_TYPE.initials, ...rest }) {
    const prevSrc = React.useRef(src);
    const [imageStatus, setImageStatus] = React.useState(typeof window === 'undefined' && src
        ? ImageLoadStates.READY
        : ImageLoadStates.LOADING);
    const isImageLoaded = imageStatus === ImageLoadStates.READY;
    React.useEffect(() => {
        initCustomElement();
    }, []);
    React.useEffect(() => {
        const isFailedLoadingImage = imageStatus === ImageLoadStates.FAILURE;
        const isSrcChanged = prevSrc.current !== src;
        if (isSrcChanged) {
            prevSrc.current = src;
            if (isFailedLoadingImage) {
                setImageStatus(ImageLoadStates.LOADING);
            }
        }
    }, [imageStatus]);
    const _onLoad = (event) => {
        setImageStatus(ImageLoadStates.READY);
        onLoad && onLoad(event);
    };
    const _onError = () => {
        setImageStatus(ImageLoadStates.FAILURE);
    };
    const imageSrc = extractWixMediaId(src) || src;
    const loadingClass = !isImageLoaded
        ? name
            ? classes.textAvatar
            : classes.anonymousAvatar
        : '';
    const contentText = !isImageLoaded && name
        ? textType === AVATAR_TEXT_TYPE.initials
            ? nameToInitials(name, lettersLimit)
            : name
        : '';
    return (React.createElement("div", { "data-content-type": src ? 'image' : name ? 'text' : 'placeholder', "data-img-loaded": isImageLoaded, "data-hook": rest['data-hook'], title: name, "aria-label": name, className: st(classes.root, className, loadingClass), "data-initials": contentText },
        React.createElement(WixImage, { height: undefined, width: undefined, className: classes.image, alt: name, uri: imageSrc, name: imageSrc, onLoad: _onLoad, onError: _onError, displayMode: "fill", imageStyles: { ...(isImageLoaded ? { opacity: 1 } : { opacity: 0 }) } })));
}
//# sourceMappingURL=Avatar.base.js.map